module.exports = __webpack_public_path__ + "static/media/chela-logo.16bd1fc2.png";